export default __webpack_public_path__ + "static/media/helper-name.d648581e.png";